import {QUESTION_SLOT_FALLBACK_CSS} from './questionSlotFallbackCss';

export const SEQUENCE_SLOT_FALLBACK_CSS = `${QUESTION_SLOT_FALLBACK_CSS.replace(
    /data-incase-slot="question"/g,
    'data-incase-slot="sequence"'
)}
[data-incase-slot="sequence"] .c-sequenceQuestionElement__answers {
  display: flex;
  flex-direction: column;
  gap: 0.5em;
}
[data-incase-slot="sequence"] .c-sequenceQuestionElement__answer {
  margin-top: 0.5em;
  pointer-events: auto;
  cursor: grab;
}
[data-incase-slot="sequence"] .c-sequenceQuestionElement__answer:first-child {
  margin-top: 0;
}
[data-incase-slot="sequence"] .c-questionElement__answer.is-correct .c-button {
  background: #dcfce7;
  color: #166534;
}
[data-incase-slot="sequence"] .c-questionElement__answer.is-incorrect .c-button {
  background: #fee2e2;
  color: #991b1b;
}
[data-incase-slot="sequence"] .c-questionElement__answer.is-debatable .c-button {
  background: #fef3c7;
  color: #92400e;
}
[data-incase-slot="sequence"] .c-sequenceQuestionClickOrder {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1em;
}
[data-incase-slot="sequence"] .c-sequenceQuestionClickOrder--mobile {
  grid-template-columns: 1fr;
}
[data-incase-slot="sequence"] .c-sequenceQuestionClickOrder__column {
  display: flex;
  flex-direction: column;
  gap: 0.5em;
  min-width: 0;
}
[data-incase-slot="sequence"] .c-sequenceQuestionClickOrder__slot {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 0.5em 0.75em;
  font-size: 0.875em;
  border: 1px dashed currentColor;
  border-radius: 0.25em;
  opacity: 0.45;
}
[data-incase-slot="sequence"] .c-sequenceQuestionClickOrder .c-button.disabled {
  opacity: 0.4;
  cursor: default;
}
[data-incase-slot="sequence"] .c-questionElement__answer.is-marked .c-button {
  outline: 2px solid currentColor;
}
[data-incase-slot="sequence"] .c-questionLayout__footer {
  display: flex;
  flex-direction: column;
  gap: 0.5em;
}
[data-incase-slot="sequence"] .c-questionLayout__footerActions {
  display: flex;
  gap: 0.5em;
  width: 100%;
}
[data-incase-slot="sequence"] .c-questionLayout__footerActions > * {
  flex: 1 1 0;
}
[data-incase-slot="sequence"] .c-sequenceQuestionClickOrder__reset {
  justify-content: center;
  text-transform: uppercase;
}
`;

export function injectSequenceSlotFallback(doc: Document): void {
    if (!doc.head || doc.head.querySelector('style[data-incase-fallback="sequence"]')) return;

    const style = doc.createElement('style');
    style.setAttribute('data-incase-fallback', 'sequence');
    style.textContent = SEQUENCE_SLOT_FALLBACK_CSS;
    doc.head.insertBefore(style, doc.head.firstChild);
}
